import { noop } from "neetocist";
import { withT } from "neetocommons/react-utils";
import { Typography, Button, Pane } from "neetoui";

import Form from "./Form";
import PublishPreview from "./PublishPreview";

const PublishSettings = withT(
  ({
    t,
    isOpen,
    onClose,
    isSubmitting = false,
    onPublish = noop,
    datetimeValue,
    setDatetimeValue,
    previewProps,
  }) => (
    <Pane {...{ isOpen, onClose }}>
      <Pane.Header>
        <Typography
          data-testid="publish-pane-heading"
          lineHeight="normal"
          style="h2"
          weight="semibold"
        >
          {t("neetoMolecules.publishBlock.publishLater")}
        </Typography>
      </Pane.Header>
      <Pane.Body>
        <div className="flex w-full flex-col gap-y-6 pb-6">
          <Form {...{ datetimeValue, onClose, setDatetimeValue }} />
          {previewProps && <PublishPreview {...previewProps} />}
        </div>
      </Pane.Body>
      <Pane.Footer className="flex items-center gap-x-2">
        <Button
          data-testid="publish-submit-button"
          disabled={isSubmitting}
          label={t("neetoMolecules.publishBlock.publishLater")}
          loading={isSubmitting}
          onClick={() => onPublish({ datetimeValue })}
        />
        <Button
          data-testid="publish-cancel-button"
          label={t("neetoMolecules.common.actions.cancel")}
          style="text"
          onClick={onClose}
        />
      </Pane.Footer>
    </Pane>
  )
);

export default PublishSettings;
